import { SettingsPage } from 'Features/Projects/Scenarios/EditSettings/SettingsPage'

export const ProductGroupingView = () => {
  return <SettingsPage title="Product grouping" />
}
